'use strict';

var animationsFactory = require('./animationsFactory');

var tweenEngineGreenSock3 = require('./tweenEngineGreenSock3');
/**
 * Constructor for a local tween engine.
 * @returns {{factory: import('./animationsFactory').AnimationFactory, engine: *}}
 * @constructor
 * @class core.animations.tweenEngine
 */


function create(gsap, plugins) {
  /** core.animations.tweenEngineGreenSock */
  var engine = tweenEngineGreenSock3.create(gsap, plugins);
  /** core.animationsFactory */

  var factory = animationsFactory.create();
  return {
    factory: factory,
    engine: engine
  };
}

module.exports = {
  create: create
};
//# sourceMappingURL=tweenEngine3.js.map